<template>
  <div :class="[pageClass, 'containerLayout']">
    <main>
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'DefaultLayout',
  props: {
    pageClass: {
      type: String
    },
  },
};
</script>

<style>
.containerLayout {
  background: RGBA(209, 0, 0, 1);
  background: linear-gradient(0deg, rgba(209, 0, 0, 1) 0%, rgba(209, 0, 0, 1) 15%, rgba(139, 4, 4, 1) 100%);
  color: white;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding: 40px 35px 35px 35px;
}

@media (min-width: 900px) {
  .containerLayout {
    padding: 60px;
  }
}

.defaultPageStart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.defaultPageCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
}
</style>
